import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import LoadingSpinner from './LoadingSpinner';

const ProtectedRoute = ({ children, adminOnly = false }) => {
  const { user, isAuthenticated, loading } = useAuth();
  const location = useLocation();

  // Show loading while checking auth status
  if (loading) {
    return <LoadingSpinner />;
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Check admin role if required (allow all admin roles)
  const adminRoles = ['viewer', 'editor', 'manager', 'admin', 'super_admin'];
  if (adminOnly && !adminRoles.includes(user?.role)) {
    return (
      <div className="container py-5 text-center">
        <div className="row justify-content-center">
          <div className="col-md-6">
            <h1 className="display-1 text-danger">403</h1>
            <h2 className="mb-4">Access Denied</h2>
            <p className="text-muted mb-4">
              You don't have permission to access this page. 
              Please contact an administrator if you believe this is an error.
            </p>
            <a href="/" className="btn btn-primary">Go to Home</a>
          </div>
        </div>
      </div>
    );
  }

  return children;
};

export default ProtectedRoute;
